import React, { PureComponent } from "react";
import "./index.scss";
import { config, srcPath, messageArr } from "@utils/config";
import VideoMenu from "@/components/videoMenu";
import Choices from "@/components/choices";
import ToastTxt from "@/components/toastTxt";
import Home from "@/components/home";
import VoiceControl from "@/components/voiceControl";
import Result from "../result";
import Play from "@/components/play";
import Music from "@/components/music";
import { connect } from "react-redux";
import vUtil from "@utils/vUtil.min.js";
import { storeChangeObject, storeMenuType } from "@action";
import { recordEven } from "@/api/actions";
class Index extends PureComponent {
  state = {
    isShowWelcomeIcon: false, //是否展示欢迎页动画
    isShowMessageTime: 0, //提示文字倒计时
    toastObj: {
      show: false,
      data: null,
      isShowHot: true,
      isShowHotContent: false
    }
  };
  componentDidMount() {
    const that = this;
    window.myVideo = document.getElementById("myVideo");
    function toPlayFn() {
      myVideo.removeEventListener("canplay", toPlayFn, false);
      const playPromise = myVideo.play();
      // 调用失败的解决方案
      if (playPromise !== undefined) {
        playPromise.then(() => {
          // 是否跳过
          if (window.isSkipVideo) {
            console.log("跳过");
            console.log(myVideo.currentTime, myVideo.duration);
            if (that.props.videoData.condition == 1) {
              myVideo.currentTime = myVideo.duration - 0.5;
            } else {
              myVideo.currentTime = that.props.videoData.conditionTime - 0.5;
            }
            console.log(myVideo.currentTime, myVideo.duration);
          } else if (window.continuePlay) {
            window.continuePlay = false;
            myVideo.currentTime = window.continuePlay + 1;
          }
        });
        playPromise.catch(() => {
          console.log("播放失败");
          //跳转至引导页
        });
      }
    }
    myVideo.toPlayFn = function() {
      myVideo.addEventListener("canplay", toPlayFn, false);
    };
    let isAutoPlay = false;
    // 自动播放是否成功
    myVideo.toPlayFn();
    if (vUtil.UA.wx) {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function() {
          toPlayFn();
        },
        false
      );
    }
    //监听播放开始
    myVideo.addEventListener(
      "play",
      function() {
        console.log("play");
        that.props.dispatch(
          storeChangeObject({
            videoPlay: true
          })
        );
      },
      false
    );
    //监听播放暂停
    myVideo.addEventListener(
      "pause",
      function() {
        console.log("pause");
        that.props.dispatch(
          storeChangeObject({
            videoPlay: false
          })
        );
        if (!isAutoPlay) {
          //跳转至引导页
          that.setState({
            isShowWelcomeIcon: true
          });
        }
      },
      false
    );
    //监听播放结束
    myVideo.addEventListener(
      "ended",
      function() {
        console.log("ended");
        that.props.dispatch(
          storeChangeObject({
            videoPlay: false
          })
        );
        if (that.props.videoData.nextPath == "end") {
          console.log("测试结束");
          that.props.dispatch(
            storeChangeObject({
              pageTag: "result"
            })
          );
          return;
        }
        that.isToNext("ended");
      },
      false
    );
    // 播放时间  判断是否成功自动播放
    myVideo.addEventListener(
      "timeupdate",
      function(e) {
        // 判断是否有提示
        that.isShowMessage();
        // 判断是否展示问题
        that.isToNext("timeupdate");
        if (myVideo.currentTime > 0.01 && !isAutoPlay) {
          isAutoPlay = true;
          that.myHome.hideWelcome();
        }
      },
      false
    );
    // 请求数据错误
    myVideo.addEventListener(
      "error",
      function(err) {
        console.log("error");
        myVideo.load();
      },
      false
    );
    // 数据不可用时
    myVideo.addEventListener(
      "stalled",
      function() {
        console.log("stalled");
      },
      false
    );
    // 加载等待
    myVideo.addEventListener(
      "waiting",
      function() {
        console.log("waiting");
      },
      false
    );
    myVideo.addEventListener("x5videoenterfullscreen", function() {
      console.log("player x5videoenterfullscreen");
      myVideo.play();
      that.props.dispatch(
        storeChangeObject({
          videoFullScreen: true
        })
      );
    });
    myVideo.addEventListener("x5videoexitfullscreen", function() {
      console.log("player x5videoexitfullscreen");
      that.props.dispatch(
        storeChangeObject({
          videoFullScreen: false
        })
      );
    });
  }
  // 判断是否需要弹出提示
  isShowMessage() {
    const nowPath = JSON.parse(localStorage.getItem("v"))
      ? JSON.parse(localStorage.getItem("v")).videoData.path
      : this.props.videoData.path;
    const messageItem = messageArr
      .filter(
        item =>
          item.path == nowPath &&
          item.time + item.keep >= parseInt(myVideo.currentTime) &&
          item.time <= parseInt(myVideo.currentTime)
      )
      .sort()
      .shift();
    if (messageItem && !this.state.toastObj.show) {
      // clearTimeout(this.state.isShowMessageTime);
      console.log(messageItem.txt);
      const toastObj = JSON.parse(JSON.stringify(this.state.toastObj));
      toastObj.show = true;
      toastObj.data = messageItem;
      this.setState({
        toastObj
      });
    }
    if (!messageItem && this.state.toastObj.show) {
      this.state.isShowMessageTime = 0;
      const toastObj = JSON.parse(JSON.stringify(this.state.toastObj));
      toastObj.show = false;
      toastObj.data = null;
      this.setState({
        toastObj
      });
    }
  }
  // 展示热点内容
  onShowHotContent(type) {
    if (type) {
      myVideo.pause();
      recordEven("展示热点");
      clearTimeout(this.state.isShowMessageTime);
      const toastObj = JSON.parse(JSON.stringify(this.state.toastObj));
      toastObj.isShowHotContent = true;
      toastObj.isShowHot = false;
      this.setState({
        toastObj
      });
    } else {
      recordEven("关闭热点");
      myVideo.play();
      const toastObj = JSON.parse(JSON.stringify(this.state.toastObj));
      toastObj.isShowHotContent = false;
      toastObj.isShowHot = true;

      this.setState({
        toastObj
      });
    }
  }
  // 检查是播放下个还是弹出问题
  isToNext(evenName) {
    const { videoData } = this.props;
    const nextPath = videoData.nextPath;
    if ("choices" in this.props.videoData && !this.props.showChoices) {
      // 满足时间节点弹出问题
      if (
        (evenName == "ended" && videoData.condition == 1) ||
        (evenName == "timeupdate" &&
          videoData.condition == 2 &&
          videoData.conditionTime == parseInt(myVideo.currentTime))
      ) {
        myVideo.pause();
        this.onChoiceFn();
      }
    }
    if (
      evenName == "ended" &&
      nextPath &&
      nextPath != "end" &&
      nextPath != "loop"
    ) {
      const seachEven =
        config
          .filter(item => item.path == nextPath && "choices" in item)
          .shift() || config.filter(item => item.path == nextPath).shift();
      // 没有问题则直接播放下个视频nextPath
      this.props.dispatch(
        storeChangeObject({
          videoSrc: srcPath[nextPath],
          videoData: seachEven
        })
      );
      // myVideo.toPlayFn();
    }
  }
  // 展示问题选项
  onChoiceFn() {
    this.props.dispatch(
      storeChangeObject({
        showChoices: 1,
        isShowMenu: false,
        choicesArr: [
          ...this.props.choicesArr,
          {
            tag: 0,
            path: this.props.videoData.path
          }
        ]
      })
    );
  }
  // 自定义选择选项
  onSelectChoices(tag) {
    const { videoData } = this.props;
    audioBtn.play();
    recordEven(
      videoData.choices.choicesArr[tag - 1].choicesBtn,
      videoData.choices.choicesTxt
    );
    // 保存选择数据
    const choicesArr = JSON.parse(JSON.stringify(this.props.choicesArr));
    choicesArr[choicesArr.length - 1].tag = tag;
    this.props.dispatch(
      storeChangeObject({
        choicesArr
      })
    );
    // 若有下个视频路径需要立即播放下个视频
    const choicesData = videoData.choices.choicesArr[tag - 1];
    if (choicesData.nextPath && choicesData.nextPath != videoData.path) {
      // 是否需要跳转下个视频
      this.props.dispatch(
        storeChangeObject({
          videoSrc: srcPath[choicesData.nextPath]
        })
      );
    } else {
      myVideo.play();
    }
    window.isSkipVideo = false;
    // myVideo.toPlayFn();
    const seachEven = choicesData.nextPath
      ? config
          .filter(
            item =>
              item.path == choicesData.nextPath &&
              "choices" in item &&
              item.condition == 2
          )
          .shift() ||
        config
          .filter(
            item =>
              item.path == choicesData.nextPath &&
              "choices" in item &&
              item.condition == 1
          )
          .shift() ||
        config.filter(item => item.path == choicesData.nextPath).shift()
      : videoData.nextPath != "end"
      ? config
          .filter(
            item =>
              item.path == videoData.nextPath &&
              "choices" in item &&
              item.condition == 2 &&
              item.conditionTime > myVideo.currentTime
          )
          .shift() ||
        config
          .filter(
            item =>
              item.path == videoData.nextPath &&
              "choices" in item &&
              item.condition == 1
          )
          .shift()
      : null;

    localStorage.setItem(
      "v",
      JSON.stringify({
        choicesArr,
        videoSrc: srcPath[choicesData.nextPath],
        videoData: seachEven
      })
    );
    // 倒计时关闭问题
    setTimeout(() => {
      // 恢复状态
      this.props.dispatch(
        storeChangeObject({
          showChoices: 2,
        })
      );
      setTimeout(() => {
        // 判断有无中间问题
        const changeStore = {
          showChoices: 0,
          isShowMenu: true
        };
        if (seachEven) {
          changeStore.videoData = seachEven;
        }
        this.props.dispatch(storeChangeObject(changeStore));
      }, 1000);
    }, 1000 * 1.2);
    // 定时出现弹窗
  }
  // 视频菜单点击
  onMenuClick(type, e) {
    e && e.stopPropagation();
    this.props.dispatch(storeMenuType(type));
  }
  onGetHome = ref => {
    this.myHome = ref;
  };
  render() {
    const { state, props } = this;
    return (
      <div>
        {/* <!-- 视频播放 --> */}
        <Play />
        {/* 音乐播放 */}
        <Music />
        {/* <!-- 声音控制 --> */}
        {props.pageTag != "result" && <VoiceControl />}
        {/* 首页 */}
        {props.pageTag == "home" && (
          <Home
            isShowWelcomeIcon={state.isShowWelcomeIcon}
            onGetHome={this.onGetHome.bind(this)}
          />
        )}
        {/* 视频播放 */}
        {props.pageTag == "index" && (
          <div
            className="b_box ov"
            onClick={this.onMenuClick.bind(this, !props.showMenu)}
          >
            {/* <!-- 播放按钮 --> */}
            <VideoMenu />
            {/* 提示文字 */}
            <ToastTxt
              onShowHotContent={this.onShowHotContent.bind(this)}
              {...state.toastObj}
            />
            <div onClick={e => e.stopPropagation()}>
              {/* 选项框 */}
              <Choices onSelectChoices={this.onSelectChoices.bind(this)} />
            </div>
          </div>
        )}
        {/* 结果页 */}
        {props.pageTag == "result" && (
          <div
            className={`result_page animated  ${
              props.videoData.nextPath == "end" ? "fadeIn" : ""
            }`}
          >
            <Result />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return state;
};
export default connect(mapStateToProps, null)(Index);
